import { useMemo } from "react";
import { useEncounterSummaryReport } from "@/queries/encounter/use-encounter-summary-report";
import { getXtenantId } from "@/utils/utils";
import {
  EncounterSummaryReport,
  NotePreviewSectionsResult,
} from "../note-preview-types";
import { flattenReportSections } from "../note-preview-utils";

export interface UseNotePreviewSections extends NotePreviewSectionsResult {
  report: EncounterSummaryReport | undefined;
}

/** Loads the sign-off report for the appointment and flattens it into preview sections. */
export const useNotePreviewSections = (
  appointmentId: string | undefined,
  enabled = true
): UseNotePreviewSections => {
  const {
    data: report,
    isFetching,
    error,
  } = useEncounterSummaryReport({
    appointmentUuid: appointmentId,
    xTENANTID: getXtenantId(),
    enabled,
  });

  const sections = useMemo(() => flattenReportSections(report), [report]);

  return useMemo(
    () => ({
      report,
      sections,
      isLoading: isFetching,
      error: error?.message,
    }),
    [report, sections, isFetching, error]
  );
};
